
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { 
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage 
} from "@/components/ui/form";

type FieldType = 'text' | 'email' | 'tel' | 'textarea';

interface CustomFormFieldProps {
  form: UseFormReturn<any>;
  name: string;
  label: string;
  placeholder?: string;
  type?: FieldType;
  required?: boolean;
  className?: string;
  rows?: number;
}

export const CustomFormField = ({ 
  form, 
  name, 
  label, 
  placeholder = "", 
  type = "text", 
  required = false,
  className = "",
  rows = 3
}: CustomFormFieldProps) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>{label}{required && <span className="text-red-500 ml-1">*</span>}</FormLabel>
          <FormControl>
            {type === 'textarea' ? (
              <Textarea 
                placeholder={placeholder} 
                className={`border-gray-300 ${form.formState.errors[name] ? 'border-red-500 focus:border-red-500' : ''}`}
                rows={rows}
                {...field}
                required={required}
              />
            ) : (
              <Input 
                type={type}
                placeholder={placeholder} 
                className={form.formState.errors[name] ? 'border-red-500 focus:border-red-500' : ''}
                {...field}
                required={required}
              />
            )}
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
